<div class="fixed inset-0 z-[60] flex items-end sm:items-center justify-center bg-[#F5F5F6] sm:bg-black/40 p-0 sm:p-4">
  <div
    class="redeem-modal bg-[#F5F5F6] sm:bg-white w-full max-w-full h-full sm:h-auto rounded-none sm:rounded-[16px] shadow-none max-h-[100dvh] sm:max-h-[95dvh] overflow-y-auto">
    <!-- ===== PASSCODE STEP ===== -->
    <ng-container *ngIf="step === 'scan'">
      <!-- Mobile header -->
      <div class="flex sm:hidden items-center gap-2 px-6 pt-7 pb-4">
        <button type="button" (click)="closeModal()" class="text-[#121212]">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <span class="text-[26px] font-medium text-[#98A2B3]">Back</span>
      </div>

      <!-- Desktop header -->
      <div class="redeem-modal__header">
        <h2 class="redeem-modal__title">{{ modalTitle }}</h2>
        <button type="button" (click)="closeModal()" class="redeem-modal__close" aria-label="Close">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>

      <div class="redeem-modal__body">
        <!-- Decorative QR section (non-functional) -->
        <div class="redeem-qr" aria-hidden="true">
          <p class="redeem-qr__label">Scan QR Code</p>
          <div class="redeem-qr__frame">
            <svg class="redeem-qr__graphic" width="220" height="220" viewBox="0 0 220 220" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M90.0989 3.66407L90.6568 3.66407C94.7531 3.66407 98.0738 6.98579 98.0738 11.0833C98.0738 15.1809 94.7531 18.5026 90.6568 18.5026C71.7996 18.5026 58.4028 18.5184 48.2399 19.8852C38.2903 21.2232 32.558 23.7326 28.3727 27.9192C24.1875 32.1057 21.6788 37.8398 20.3412 47.7924C18.9748 57.9584 18.959 71.3593 18.959 90.2222C18.959 94.3198 15.6383 97.6415 11.542 97.6415C7.44572 97.6415 4.12501 94.3198 4.12501 90.2222L4.125 89.6641C4.12485 71.4843 4.12472 57.0847 5.63941 45.8152C7.19825 34.2172 10.4827 24.8298 17.8835 17.4267C25.2843 10.0237 34.6688 6.73825 46.2633 5.17893C57.5294 3.66378 71.9246 3.66391 90.0989 3.66407ZM172.631 19.8852C162.468 18.5184 149.071 18.5026 130.214 18.5026C126.118 18.5026 122.797 15.1809 122.797 11.0833C122.797 6.98579 126.118 3.66407 130.214 3.66407L130.772 3.66407C148.946 3.66391 163.342 3.66378 174.608 5.17893C186.202 6.73825 195.587 10.0237 202.988 17.4267C210.388 24.8298 213.673 34.2172 215.232 45.8152C216.746 57.0847 216.746 71.4844 216.746 89.6642V90.2222C216.746 94.3198 213.425 97.6415 209.329 97.6415C205.233 97.6415 201.912 94.3198 201.912 90.2222C201.912 71.3593 201.896 57.9584 200.53 47.7924C199.192 37.8398 196.684 32.1057 192.498 27.9192C188.313 23.7326 182.581 21.2232 172.631 19.8852ZM11.542 122.372C15.6383 122.372 18.959 125.694 18.959 129.792C18.959 148.655 18.9748 162.055 20.3412 172.222C21.6788 182.174 24.1875 187.908 28.3727 192.095C32.558 196.281 38.2903 198.791 48.2399 200.129C58.4028 201.496 71.7996 201.511 90.6568 201.511C94.7531 201.511 98.0738 204.833 98.0738 208.931C98.0738 213.028 94.7531 216.35 90.6568 216.35H90.099C71.9247 216.35 57.5294 216.35 46.2633 214.835C34.6688 213.276 25.2843 209.99 17.8835 202.587C10.4827 195.184 7.19825 185.797 5.63941 174.199C4.12472 162.929 4.12485 148.53 4.125 130.35L4.12501 129.792C4.12501 125.694 7.44572 122.372 11.542 122.372ZM209.329 122.372C213.425 122.372 216.746 125.694 216.746 129.792V130.35C216.746 148.53 216.746 162.929 215.232 174.199C213.673 185.797 210.388 195.184 202.988 202.587C195.587 209.99 186.202 213.276 174.608 214.835C163.342 216.35 148.946 216.35 130.772 216.35H130.214C126.118 216.35 122.797 213.028 122.797 208.931C122.797 204.833 126.118 201.511 130.214 201.511C149.071 201.511 162.468 201.496 172.631 200.129C182.581 198.791 188.313 196.281 192.498 192.095C196.684 187.908 199.192 182.174 200.53 172.221C201.896 162.055 201.912 148.655 201.912 129.792C201.912 125.694 205.233 122.372 209.329 122.372Z"
                fill="#B0B0B0" />
              <path
                d="M83.6667 29.998H136.833C161.896 29.998 174.428 29.998 182.214 37.1852C189.524 43.9328 189.971 54.5414 189.998 74.9584L190 109.953V140.421C190 163.556 190 175.124 182.214 182.311C174.428 189.498 161.896 189.498 136.833 189.498H83.6667C58.6037 189.498 46.0722 189.498 38.2861 182.311C30.5 175.124 30.5 163.556 30.5 140.421V109.954L30.5018 74.9586C30.5291 54.5414 30.9762 43.9328 38.2861 37.1852C46.0722 29.998 58.6037 29.998 83.6667 29.998Z"
                fill="#B0B0B0" />
            </svg>
          </div>
          <p class="redeem-qr__hint">Position QR code within frame</p>
        </div>

        <div class="redeem-qr-banner">
          <svg class="redeem-qr-banner__icon" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" aria-hidden="true">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <span>Download Bucca Mobile App to able to scan QR Code</span>
        </div>

        <div class="redeem-pin">
          <div class="redeem-pin__row">
            <div
              *ngFor="let digit of pinDigits; let i = index; trackBy: trackByIndex"
              class="redeem-pin__cell"
              [class.redeem-pin__cell--filled]="pinDigits[i]"
            >
              <input
                #pinInput
                type="text"
                inputmode="text"
                autocomplete="off"
                maxlength="1"
                placeholder="-"
                [ngModel]="pinDigits[i]"
                (ngModelChange)="onPinDigitChange(i, $event)"
                (keydown)="onPinKeydown(i, $event)"
                (paste)="onPinPaste($event)"
                class="redeem-pin__input pin-box"
                [attr.aria-label]="'Passcode character ' + (i + 1)"
              />
            </div>
          </div>
        </div>

        <p *ngIf="lookupError" class="text-[12px] text-[#B42318] text-center mt-3 mb-0">{{ lookupError }}</p>
      </div>

      <!-- Mobile footer -->
      <div class="px-6 pb-6 sm:hidden">
        <button
          type="button"
          (click)="submitPinLookup()"
          [disabled]="!isPinComplete || isLookingUp"
          class="w-full justify-center px-6 py-4 text-[14px] font-medium rounded-[10px] flex items-center gap-2 text-white disabled:opacity-50 disabled:cursor-not-allowed"
          [ngClass]="isPinComplete ? 'bg-[#C9302C] hover:bg-[#B62622]' : 'bg-[#D0D5DD]'"
        >
          {{ isLookingUp ? 'Validating...' : submitLabel }}
        </button>
      </div>

      <!-- Desktop footer -->
      <div class="redeem-modal__footer">
        <button type="button" (click)="closeModal()" class="redeem-btn-cancel">Cancel</button>
        <button
          type="button"
          (click)="submitPinLookup()"
          [disabled]="!isPinComplete || isLookingUp"
          class="redeem-btn-primary"
        >
          {{ isLookingUp ? 'Validating...' : submitLabel }}
          <svg *ngIf="!isLookingUp" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2" aria-hidden="true">
            <line x1="5" y1="12" x2="19" y2="12" />
            <polyline points="12 5 19 12 12 19" />
          </svg>
        </button>
      </div>
    </ng-container>

    <!-- ===== DETAILS STEP ===== -->
    <ng-container *ngIf="step === 'details' && booking && statusDisplay">
      <!-- Mobile header -->
      <div class="flex sm:hidden items-center gap-2 px-6 pt-7 pb-4">
        <button type="button" (click)="backToScan()" class="text-[#121212]">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <span class="text-[26px] font-medium text-[#98A2B3]">Back</span>
      </div>

      <!-- Desktop header -->
      <div
        class="hidden sm:flex items-center justify-between px-5 sm:px-6 py-4 border-b border-[#E6E6E6] sticky top-0 bg-white z-10">
        <h2 class="text-[16px] font-semibold text-[#121212]">Redeem Booking</h2>
        <button type="button" (click)="closeModal()"
          class="w-8 h-8 flex items-center justify-center rounded-full border-2 border-[#121212] hover:bg-gray-50">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>

      <div class="px-6 sm:px-6 py-4 sm:py-5 space-y-4">
        <!-- Staff card -->
        <div class="border border-[#D0D5DD] rounded-[12px] p-4 flex items-center gap-3 bg-[#F5F5F6] sm:bg-white">
          <div class="w-12 h-12 rounded-[10px] bg-[#EAECF0] flex items-center justify-center shrink-0">
            <span class="text-[14px] sm:text-[14px] font-bold text-[#121212]">{{ booking.staffInitials }}</span>
          </div>
          <div>
            <p class="text-[14px] sm:text-[15px] font-semibold text-[#121212]">{{ booking.staffName }}</p>
            <p class="text-[13px] text-[#6A6A6A]">{{ booking.staffRole }}</p>
          </div>
        </div>

        <!-- Booking card -->
        <div class="border rounded-[12px] overflow-hidden bg-[#F5F5F6] sm:bg-white"
          [ngClass]="statusDisplay.cardBorder">
          <div class="flex items-center justify-between px-4 py-3 border-b"
            [ngClass]="[statusDisplay.headerBg, statusDisplay.headerBorder]">
            <div class="flex items-center gap-2">
              <span class="w-5 h-5 rounded-full flex items-center justify-center shrink-0">
                <svg *ngIf="statusDisplay.iconType === 'check'" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="#027A48" stroke-width="2.5">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                <svg *ngIf="statusDisplay.iconType === 'x'" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="#D92D20" stroke-width="2.5">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </span>
              <span class="text-[14px] font-semibold" [ngClass]="statusDisplay.textClass">{{ statusDisplay.label
                }}</span>
            </div>
            <span class="text-[14px] sm:text-[14px] font-bold text-[#121212] tracking-wider">{{ booking.pin }}</span>
          </div>

          <div class="p-4">
            <div class="flex gap-3 mb-4">
              <img [src]="booking.mealImage" [alt]="booking.mealName"
                class="w-16 h-16 rounded-[10px] object-cover shrink-0 bg-[#F2F4F7]" />
              <div class="min-w-0">
                <p class="text-[15px] sm:text-[14px] font-semibold text-[#121212] leading-snug mb-0.5">{{
                  booking.mealName }}</p>
                <p *ngIf="booking.vendorName" class="text-[14px] sm:text-[12px] text-[#6A6A6A] mb-2">{{
                  booking.vendorName }}</p>
                <div class="flex flex-wrap gap-2">
                  <span
                    class="px-2 py-0.5 rounded-[6px] text-[11px] sm:text-[10px] font-semibold text-white bg-[#2E5FCC]">{{
                    booking.mealTypeTag }}</span>
                  <span
                    class="px-2 py-0.5 rounded-[6px] text-[11px] sm:text-[10px] font-semibold text-[#344054] bg-[#E7E7E8] border border-[#D0D5DD]">{{
                    booking.dietaryTag }}</span>
                </div>
              </div>
            </div>

            <div class="border-t border-[#D0D5DD] pt-3 space-y-2">
              <div class="flex items-center gap-2">
                <p class="text-[14px] text-[#6A6A6A]">Serving Time</p>
                <p class="text-[14px] font-medium" [ngClass]="statusDisplay.servingTimeClass">{{ booking.servingTime }}
                </p>
              </div>
              <div class="flex items-center gap-2">
                <p class="text-[14px] text-[#6A6A6A]">Cafeteria</p>
                <p class="text-[14px] font-medium text-[#121212]">{{ booking.cafeteria }}</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Info banner -->
        <div *ngIf="booking.infoBanner"
          class="flex items-center gap-2 px-4 py-3 rounded-[10px] bg-[#E8EDF8] border border-[#BAC5DF]">
          <svg class="shrink-0 text-[#175CD3]" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <span class="text-[14px] font-medium text-[#1D2939]">{{ booking.infoBanner }}</span>
        </div>
      </div>

      <div
        class="px-6 sm:px-6 pb-6 sm:py-4 sm:border-t sm:border-[#E6E6E6] flex flex-col-reverse sm:flex-row sm:justify-end gap-3">
        <button type="button" (click)="backToScan()"
          class="w-full sm:w-auto justify-center px-6 py-4 sm:py-2.5 text-[14px] font-medium text-[#101828] border border-[#D0D5DD] rounded-[10px] sm:rounded-[8px] hover:bg-gray-50 bg-[#F5F5F6] sm:bg-white">
          Cancel
        </button>
        <button type="button" (click)="confirmRedemption()" [disabled]="!statusDisplay.canConfirm || isConfirming"
          class="w-full sm:w-auto justify-center px-6 py-4 sm:py-2.5 text-[14px] sm:text-[14px] font-medium rounded-[10px] sm:rounded-[8px] transition-colors"
          [ngClass]="statusDisplay.confirmButtonClass">
          {{ isConfirming ? 'Confirming...' : 'Confirm Booking' }}
        </button>
      </div>
    </ng-container>

    <!-- ===== SUCCESS STEP ===== -->
    <ng-container *ngIf="step === 'success' && (redeemedBooking || guestClaimResult)">
      <div class="px-5 sm:px-6 py-10 text-center">
        <div
          class="w-20 h-20 mx-auto mb-5 rounded-full bg-[#ECFDF3] border-4 border-[#ABEFC6] flex items-center justify-center">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#027A48" stroke-width="2.5">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        <ng-container *ngIf="mode === 'guest' && guestClaimResult; else bookingSuccess">
          <h2 class="text-[20px] font-bold text-[#027A48] mb-2">Guest Redemption Successful</h2>
          <p class="text-[14px] font-medium text-[#121212] mb-1">{{ guestClaimResult.guestName }}</p>
          <p class="text-[13px] text-[#6A6A6A] mb-4">
            {{ guestClaimResult.numberOfMeals }} meal{{ guestClaimResult.numberOfMeals === 1 ? '' : 's' }} redeemed
          </p>

          <ul class="text-left border border-[#E6E6E6] rounded-[10px] divide-y divide-[#E6E6E6] mb-4 max-w-sm mx-auto">
            <li *ngFor="let meal of guestClaimResult.meals" class="px-4 py-2.5 text-[14px] text-[#121212]">
              {{ meal.name }}
            </li>
          </ul>

          <p *ngIf="guestClaimResult.confirmedBy" class="text-[12px] text-[#98A2B3] mb-6">
            Confirmed by {{ guestClaimResult.confirmedBy }}
          </p>
        </ng-container>

        <ng-template #bookingSuccess>
          <h2 class="text-[20px] font-bold text-[#027A48] mb-2">Redemption Successful</h2>
          <p class="text-[14px] text-[#6A6A6A] mb-1">{{ redeemedBooking?.mealName }}</p>
          <p class="text-[14px] font-medium text-[#121212] mb-6">{{ redeemedBooking?.staffName }}</p>
          <p class="text-[12px] text-[#98A2B3] mb-6">Passcode is now inactive for this booking.</p>
        </ng-template>

        <button type="button" (click)="finishSuccess()"
          class="w-full sm:w-auto px-8 py-3 bg-[#027A48] hover:bg-[#026939] text-white text-[14px] font-medium rounded-[8px]">
          Done
        </button>
      </div>
    </ng-container>
  </div>
</div>
